import React from 'react'
import { Col, Row } from 'reactstrap'

const HomeBookAppointment = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding5rem1 right-padding5rem1 p-top-bottom2rem' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/04/Middle-Section-Background.jpg")', height:'100%' , width:'100%'}}>
            <div className='pt-md-5'>
                <Row>
                    <Col md='12' lg='4' style={{ display:'grid', alignItems:'center'}}>
                        <div className='flex-center6' >
                            
                            <div className='pb-3 flex-center6'>
                                <img src='https://unitedlabcare.com/wp-content/uploads/2022/02/UCC-Favicon.webp' alt='Tick Mark' height='auto' width='70px'  />
                            </div>

                            <div className='flex-center1'>
                                <text className='fs-ss-36 text-montserrat fw-700 text-ss-primary lh-1-2' style={{ textTransform:'uppercase'}}>How to book</text>
                            </div>

                            <div className=''>
                                <text className='fs-ss-38-1 text-montserrat fw-600 text-ss-secondary lh-1-2' style={{ textTransform:'uppercase'}}>an appointment</text>
                            </div>

                        </div>
                    </Col>
                    <Col md='12' lg='8'>
                        <div className='py-4 ps-md-4' style={{ borderRadius:'0 5px 5px 5px'}}>
                            {/* <video src='https://www.youtube.com/embed/k8Gd63X81Y8?autoplay=0&controls=0&disablekb=1&playsi  nline=true&cc_load_policy=0&cc_lang_pref=auto&widget_referrer=https%3A%2F%2Funitedlabcare.com%2F&rel=0&showinfo=0&iv_load_policy=3&modestbranding=1&customControls=true&noCookie=false&enablejsapi=1&origin=https%3A%2F%2Funitedlabcare.com&widgetid=1'  height='auto' width='100%' /> */}
                            <iframe title='s' width='100%' height='435' controls={1} poster='https://i.ytimg.com/vi/k8Gd63X81Y8/maxresdefault.jpg' style={{ borderWidth:'8px 8px 8px 8px', borderStyle:'solid', borderColor:'#2076AD #EB242B #EB242B #2076AD' , borderRadius:'5px 5px 5px 5px'}}
                                src='https://www.youtube.com/embed/k8Gd63X81Y8?autoplay=0&controls=1&disablekb=1&playsinline=true&cc_load_policy=0&cc_lang_pref=auto&widget_referrer=https%3A%2F%2Funitedlabcare.com%2F&rel=0&showinfo=0&iv_load_policy=3&modestbranding=0&customControls=true&noCookie=false&enablejsapi=1&origin=https%3A%2F%2Funitedlabcare.com&widgetid=1'>
                            </iframe>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
  )
}

export default HomeBookAppointment